var version = {
    "name":      "dativery",
    "buildDateCode": "20260326-155500",
    "buildDate": "Thu Mar 26 2026 15:55:00 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260326-155500",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;